import { createFileRoute } from "@tanstack/react-router";
import { CelebrityResultPage } from "@/components/site/CelebrityResultPage";
import { mattForte } from "@/lib/celebrity-results/matt-forte";
import { absoluteUrl } from "@/lib/absolute-url";

const TITLE = "Matt Forte Hair Transplant Results | RESTORE® Hair";
const DESC = "See former NFL running back Matt Forte's RESTORE® No-Shave FUE™ hair transplant results, before & after photos and his full hair restoration story.";
const POSTER = "/img/r/wp-2024-09-restore-mattforte-after-72-5-1.webp";

export const Route = createFileRoute("/results/matt-forte")({
  head: () => ({
    meta: [
      { title: TITLE },
      { name: "description", content: DESC },
      { property: "og:title", content: TITLE },
      { property: "og:description", content: DESC },
      { property: "og:type", content: "article" },
      { property: "og:url", content: "https://restorehair.com/results/matt-forte/" },
      { property: "og:image", content: absoluteUrl(POSTER) },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: absoluteUrl(POSTER) },
    ],
    links: [
      { rel: "canonical", href: "https://restorehair.com/results/matt-forte/" },
    ],
  }),
  component: () => <CelebrityResultPage data={mattForte} />,
});
